import React,{Component} from 'react';
import './KPI6.css';

import Select from '@acri-tools/react-tools/components/Select/Select';
import KPIs from '../KPIs';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { IonCheckbox } from '@ionic/react';
import request from '@acri-tools/react-tools/utils/request';
import { API_URL } from '../../../_utils/config';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import { date_day_diff } from '../../../_utils/kpi';
import FormFieldCheckbox from '@acri-tools/react-tools/components/FormFieldCheckbox/FormFieldCheckbox';
import classNames from 'classnames';
import { connect } from 'react-redux';

interface Props{
    kpi?:any
}
interface State{
    loading:boolean
    data?:any
    selected:Array<string>

    // export
    json_format:boolean
}

/**
 *  1. KPI SELECT
 *  2. LIst of anomalies (no filter seearch nada) with toggle for export (add IPF column with version) 
 */

class KPI6 extends Component<Props, State> {
    
    constructor(props:Props){
        super(props);
        this.state={
            selected: [],
            loading: false,
            json_format: false,
        }
    }
    componentDidMount(){
        this.fetch_data(true)
    }
    // async componentDidUpdate(prevProps:Props) {
    //     if(prevProps.kpi?.refresh !== this.props.kpi?.refresh){
    //         await this.setState({
    //             ...this.default_values(true)
    //         })
    //         this.fetch_data(true)
    //     }
    // }

    fetch_data = async(refresh?:boolean) => {
        if(refresh) this.setState({ loading: true })
        try {
            let res = await request(`${API_URL}/api/v1/anomalies`,{
                method:'get',
                responseType:'json',
                serializer:'json',
                params:{
                    limit: 4500,
                    orderby: 'creation_date_time asc'
                }
            })
            this.setState({ data:res.data.value });
        }
        catch (e) {
            axiosErrorHandler( e, { 
                functionName: 'fetch_kpi_data'
            })
        }
        finally {
            if(refresh) this.setState({ loading: false });
        }
    }

    render(){
        return (
            <KPIs 
                title="CFI data processor anomaly reporting​"
            >

                {/* GRAPH */}
                <div className="title-3">Anomalies</div>
                {
                    this.state.loading ?
                        <div className="centered">
                            <Spinner />
                        </div>
                        :
                        this.state.data &&
                        <table className="table-kpi">
                            <thead>
                                <tr>
                                    <th>
                                        <IonCheckbox checked={this.state.selected.length === this.state.data?.length} onClick={(e:any)=>{
                                            if(this.state.selected.length === this.state.data?.length){
                                                this.setState({ selected: [] });
                                            }
                                            else{
                                                this.setState({ selected: this.state.data.map((d:any)=>{ return d.id }) });
                                            }
                                        }}/> All
                                    </th>
                                    <th>IPF</th>
                                    <th>CAMS Ticket Creation</th>
                                    <th>Start Date</th>
                                    <th>Stop Date</th>
                                    <th>Description</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.data.map((a: any, key: number) => (
                                        <tr key={key}>
                                            <td>
                                                <IonCheckbox 
                                                    onClick={(e)=>{
                                                        let { selected } = this.state;
                                                        if(this.state.selected.includes(a.id)){
                                                            let idx = selected.indexOf(a.id);
                                                            selected.splice(idx, 1);
                                                        }
                                                        else{
                                                            selected.push(a.id)
                                                        }
                                                        this.setState({ selected })
                                                    }}
                                                    checked={this.state.selected.includes(a.id)} />
                                            </td>
                                            <td>{a.ipf}</td>
                                            <td>{a.creation_date_time}</td>
                                            <td>{a.start_date_time}</td>
                                            <td>{a.stop_date_time}</td>
                                            <td>{a.description}</td>
                                            <td>{date_day_diff(a.start_date_time, a.stop_date_time)}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                }
                <br/>
                <br/>
                {/* DOWNLOAD */}
                <div className="title-3">Export</div>
                <p>Export Data used to compute the KPI</p>

                <FormFieldCheckbox
                    notSolid label="JSON Format"
                    value={!!this.state.json_format}
                    onChange={(json_format: boolean) => { this.setState({ json_format }) }}
                />
                <a 
                    className={classNames({
                        "custom-button medium inline": true,
                        "disabled": this.state.selected.length === 0
                    })}
                    href={this.download_url()} download
                >
                    <i className="fas fa-cloud-download-alt" /> Export
                </a>
            </KPIs>
        );
    }

    download_url = () => {
        let params = [
            // 'expand=product,sensing_product',
            'export=true',
        ];
        params.push(`exports=${this.state.selected.join(',')}`);
        if(this.state.json_format) params.push('format=json');
        
        return `${API_URL}/api/v1/anomalies?${params.join('&')}`
    }



};



export default connect((state:any)=>{
    return {
        kpi: state.kpi
    }
})(KPI6)